module.exports = __webpack_public_path__ + "img/icons_8.770530c3.png";